<style lang="scss" src="./PrintConfig.scss" />
<template>
  <div class="wrapper wrapper-content animated fadeIn PrintConfig">
    <div class="container row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="save">
              <h2>Informações de Impressão</h2>
              <div class="space-25"></div>
              <div class="form-group">
                <label>Título</label>
                <input type="text" class="form-control" v-model="form.brand" />
              </div>
              <div class="form-group">
                <label>Cabeçalho</label>
                <textarea class="form-control textarea" v-model="form.header" />
              </div>
              <div class="form-group">
                <label>Sub Cabeçalho de Pós Utilização</label>
                <textarea
                  class="form-control textarea"
                  v-model="form.irregularSubHeader"
                />
              </div>
              <div class="form-group">
                <label>QrCode do rodapé</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.footerQrCode"
                />
              </div>
              <div class="form-group">
                <label>Rodapé</label>
                <textarea class="form-control textarea" v-model="form.footer" />
              </div>

              <br />
              <button class="btn btn-block btn-primary compose-mail">
                <i class="fa fa-save"></i>
                Salvar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  data() {
    return {
      form: {
        brand: '',
        header: '',
        irregularSubHeader: '',
        footerQrCode: '',
        footer: '',
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async save() {
      try {
        await this.$store.dispatch('PRINT-CONFIG/Save', this.form);
        toast.success('Salvo com sucesso');
      } catch (error) {
        toast.error('Falha ao salvar impressão');
      }
    },
    async load() {
      try {
        const printConfig = await this.$store.dispatch('PRINT-CONFIG/Load');
        this.form.brand = printConfig.brand;
        this.form.header = printConfig.header;
        this.form.irregularSubHeader = printConfig.irregularSubHeader;
        this.form.footerQrCode = printConfig.footerQrCode;
        this.form.footer = printConfig.footer;
      } catch (error) {
        toast.error('Falha ao abrir impressão');
      }
    },
  },
};
</script>
